export function isTouchPointer(event) {
  return event.pointerType === 'touch' || event.pointerType === 'pen';
}
